module.exports = __webpack_public_path__ + "img/infoImg-5.1e5ca5e8.jpg";